import React, { useState, Fragment, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";
import { Listbox, Transition } from "@headlessui/react";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";

const Calendar = ({ selectedDate, setSelectedDate, getHomeData }) => {
  const [date, setDate] = useState(new Date());

  const [isOpen, setIsOpen] = useState(false);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const days = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();
    return { days, firstDay };
  };

  const { days, firstDay } = getDaysInMonth(date);
  console.log("Selected Date", selectedDate);
  const prevMonth = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() - 1));
  };

  const nextMonth = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() + 1));
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getData = (date) => {
    console.log("Date", date);
    setSelectedDate(date);
    getHomeData(date);
  };

  return (
    <div className="w-full max-w-md mx-auto">
      <div>
        <h1 className="text-lg text-green mb-1.5">Dagsorden</h1>
        <h2 className="text-xl font-bold text-black">
          {formatDate(selectedDate)}
        </h2>
        <div className="rounded-2xl bg-white p-4 shadow-lg mt-6">
          <div className="flex items-center justify-between mb-4">
            <Listbox
              value={date.getMonth()}
              onChange={(monthIndex) =>
                setDate(new Date(date.getFullYear(), monthIndex))
              }
            >
              <div className="relative w-[200px]">
                <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-2 pl-3 pr-10 text-left border focus:outline-none border-0">
                  <span className="block truncate text-gray font-semibold">{`${
                    months[date.getMonth()]
                  } ${date.getFullYear()}`}</span>
                  <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2 ">
                    <ChevronRightIcon
                      className="h-5 w-5 text-black rotate-90"
                      aria-hidden="true"
                    />
                  </span>
                </Listbox.Button>
                <Transition
                  as={Fragment}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1">
                    {months.map((month, index) => (
                      <Listbox.Option
                        key={index}
                        value={index}
                        className={({ active }) =>
                          `relative cursor-pointer select-none py-2 pl-10 pr-4 ${
                            active
                              ? "bg-blue-100 text-blue-900"
                              : "text-gray-900"
                          }`
                        }
                      >
                        {month} {date.getFullYear()}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </Listbox>
            <div className="flex gap-1">
              <button
                type="button"
                onClick={prevMonth}
                className="inline-flex items-center justify-center rounded-full p-2 text-gray-500 hover:bg-gray-100"
              >
                <ChevronLeftIcon className="h-5 w-5 text-black" />
              </button>
              <button
                type="button"
                onClick={nextMonth}
                className="inline-flex items-center justify-center rounded-full p-2 text-gray-500 hover:bg-gray-100"
              >
                <ChevronRightIcon className="h-5 w-5 text-black" />
              </button>
            </div>
          </div>
          <div className="grid grid-cols-7 gap-2 text-center mb-2">
            {["S", "M", "T", "W", "T", "F", "S"].map((day) => (
              <div key={day} className="text-sm font-semibold">
                {day}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-2 text-center">
            {Array.from({ length: firstDay }).map((_, index) => (
              <div key={`empty-${index}`} />
            ))}
            {Array.from({ length: days }).map((_, index) => {
              const day = index + 1;
              const currentDate = new Date(
                date.getFullYear(),
                date.getMonth(),
                day
              );
              const isSelected =
                currentDate.toDateString() === selectedDate.toDateString();
              const isToday =
                currentDate.toDateString() === new Date().toDateString();
              return (
                <button
                  key={day}
                  type="button"
                  className={`h-8 w-8 text-black p-5 text-sm rounded-full flex items-center justify-center ${
                    isSelected ? "bg-theme !text-white" : "hover:bg-gray-100"
                  } ${
                    isToday &&
                    !isSelected &&
                    "border border-[#2BBAF0] text-theme"
                  }`}
                  onClick={() => getData(currentDate)}
                >
                  {day}
                </button>
              );
            })}
          </div>
          <div className="flex justify-end mt-8 gap-5 text-sm">
            <button className="text-theme font-semibold">Cancel</button>
            <button className="text-theme font-semibold">OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Calendar;
